import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

/**
 * Shown only when the salesperson is "Affiliate" — picks which affiliate brought
 * the booking in. The roster is managed in Affiliate Management.
 *
 * `placeholder` exists for the insurance pages, which call the same person a
 * partner (INS-017). Every other caller gets the wording below unchanged, and
 * the empty state deliberately still names Affiliate Management, because that
 * is still what the page is called.
 */
export default function AffiliatePicker({
  id, value, onChange, testid = "bookings-field-affiliate_name",
  placeholder = "Which affiliate?",
}) {
  const [names, setNames] = useState([]);

  useEffect(() => {
    api.get("/affiliates")
      .then(({ data }) => setNames((data || []).filter((a) => a.active !== false).map((a) => a.name)))
      .catch(() => setNames([]));
  }, []);

  // A name already saved on the record is always kept as an option — same rule
  // as the Leads salesperson picker — so an affiliate who was renamed,
  // deactivated or typed in from the old spreadsheet never silently disappears.
  const options = value && !names.includes(value) ? [value, ...names] : names;

  return (
    <>
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger id={id} className="bg-input border-border" data-testid={testid}>
          <SelectValue placeholder={options.length ? placeholder : "No affiliates added yet"} />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {options.map((n) => <SelectItem key={n} value={n}>{n}</SelectItem>)}
        </SelectContent>
      </Select>
      {options.length === 0 && (
        <p className="text-xs text-muted-foreground mt-1.5">Add affiliates in Affiliate Management first.</p>
      )}
    </>
  );
}
